import {Option} from './Option';

export type GroupedOption = {
  label: string;
  options: Option[];
};
